import { BranchConstants as Constants } from '../../types'

const initialState = {
    branches: [],


};

export function branchReducer(state = initialState, action) {
    switch (action.type) {  
        case Constants.GET:            
            return {
                ...state,
                branches: action?.payload?.branches,                
            };

   
            
        case Constants.ADD:
            return {
                ...state,
                branches: [...state?.branches, action?.payload?.branch]
            }

        case Constants.UPDATE:            
            const index = state.branches.findIndex(x => parseInt(x.id) ===  parseInt(action?.payload?.branch?.id))
            const newArray = [...state.branches];
            if(index > -1)
                newArray[index] = action?.payload?.branch
            return {
                ...state,
                branches: newArray                
            }   

        case Constants.DELETE:
            return{
                ...state,
                branches: state?.branches?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id))                
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null
            }

        case Constants.CLEAR:
            return{
                ...state,
                branches: []
            }
        default:
            return state
    }
}